import { GlobalStyles } from './GlobalStyles';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { PropagationProvider } from './PropagationProvider';
import { LazyMotion } from 'framer-motion';
import { KeyboardModeProvider } from './KeyboardModeProvider';
import { GlobalCSSVariables } from './GlobalCSSVariables';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const loadAnimationFeaturesWithRetry = (retries = 2) => import( /* webpackChunkName: "framer-motion-animation-features" */
'./animation-features.ts').then(res => res.default).catch(error => {
  if (retries > 0) {
    return loadAnimationFeaturesWithRetry(retries - 1);
  } else {
    throw error;
  }
});
const loadAnimationFeatures = () => loadAnimationFeaturesWithRetry(0);
const MaybeLazyMotion = ({
  children,
  enable,
  retry
}) => enable ? /*#__PURE__*/_jsx(LazyMotion, {
  features: retry ? loadAnimationFeaturesWithRetry : loadAnimationFeatures,
  strict: true,
  children: children
}) : /*#__PURE__*/_jsx(_Fragment, {
  children: children
});
let hasRenderedProvider = false;
const enabledInAllAppProviders = {
  globalCSSVariables: true
};
const enabledInMainAppProvider = {
  globalCSSVariables: true
};
export function setEnabledInAllAppProviders(overrides) {
  if (hasRenderedProvider) {
    // TODO warn
  }
  Object.assign(enabledInAllAppProviders, overrides);
}
export function resetEnabledInAllAppProviders() {
  Object.assign(enabledInAllAppProviders, enabledInMainAppProvider);
}
export const AppProvider = ({
  themeName = 'classic',
  themeMode = 'light',
  applyGlobalStyles = false,
  continuePropagation = false,
  children,
  enableAnimationFeatures = true,
  unstable_retryLazyMotionDynamicImport = true,
  // while the default is false, the value only matters if `setEnabledInAllAppProviders` has been called
  isMainAppProvider = false
}) => {
  hasRenderedProvider = true;
  const enabledFeatures = isMainAppProvider ? enabledInMainAppProvider : enabledInAllAppProviders;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    themeName: themeName,
    themeMode: themeMode,
    children: /*#__PURE__*/_jsx(MaybeLazyMotion, {
      retry: unstable_retryLazyMotionDynamicImport,
      enable: enableAnimationFeatures,
      children: /*#__PURE__*/_jsx(KeyboardModeProvider, {
        children: /*#__PURE__*/_jsxs(PropagationProvider, {
          continuePropagation: continuePropagation,
          children: [enabledFeatures.globalCSSVariables ? /*#__PURE__*/_jsx(GlobalCSSVariables, {
            themeName: themeName,
            themeMode: themeMode
          }) : null, applyGlobalStyles ? /*#__PURE__*/_jsx(GlobalStyles, {}) : null, children]
        })
      })
    })
  });
};